module.exports = __webpack_public_path__ + "images/b6bd2abfd1cd27ecd72ef3f65cfb310e.png";